import { Component, OnInit } from '@angular/core';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { AirSpaceBoundaryModel } from 'src/app/models/air-space-boundary';
import { TrajectoryModel } from 'src/app/models/Trajectory';
import { SelectCoordinatePointsControlService } from 'src/app/popup/services/select-coordinate-points-control.service';
import { AirSpaceBoundaryFilterService } from 'src/app/services/air-space-bondary-filter.service';
import { AirspaceBoundariesControlService } from 'src/app/services/airspace-boundaries-control.service';
import { PointsService } from 'src/app/services/points.service';
import { TabsService } from 'src/app/services/tabsService';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { TrajectoryFilterService } from 'src/app/services/trajectory-filter.service';
import { TrajectoryService } from 'src/app/services/trajectory.service';

@Component({
  selector: 'app-trajetcory-filter',
  templateUrl: './trajetcory-filter.component.html',
  styleUrls: ['./trajetcory-filter.component.scss'],
  standalone: false
})
export class TrajetcoryFilterComponent implements OnInit {

  selectedTrajercory: TrajectoryModel;

  constructor(public trajectoryFilterService : TrajectoryFilterService,
    public menuController : MenuManagementService,
    private toolsService : ToolsControlService,
    private pointsService : PointsService,
    public  selectCoordinatePointService : SelectCoordinatePointsControlService,
    public trajectoryController: TrajectoryService,
    public tabsService :  TabsService
    ) { }

  ngOnInit(): void {
  }

  cancelWindow():void{
    this.trajectoryFilterService.active = !this.trajectoryFilterService.active;
    this.toolsService.navigationOnTop = false;
  }

  addToMap() : void {
    let selectedTrajectories : TrajectoryModel[] = [];
    this.trajectoryController.trajectories.forEach( traj => {
      if(traj.isselected) {
        traj.mapstatus = true;
        selectedTrajectories.push(traj);
      }
    });
    this.trajectoryController.bulkUpdateTrajectoriesStatus(selectedTrajectories);

  }

  removeFromMap() : void {
    let selectedTrajectories : TrajectoryModel[] = [];
    this.trajectoryController.trajectories.forEach( traj => {
      if(traj.isselected) {
        traj.mapstatus = false;
        selectedTrajectories.push(traj);
      }
    });

    this.trajectoryController.bulkUpdateTrajectoriesStatus(selectedTrajectories);

  }

  deselectAll() {
    this.trajectoryController.trajectories.forEach( traj => {
      traj.isselected = false;

    });
  }
  selectAll() {
    this.trajectoryController.trajectories.forEach( traj => {
      traj.isselected = true;
    });
  }

}
